import {
  dialogSearchFieldSx,
  getDialogPaperSx
} from '../../../constants/dialogSx'
import {
  UI_COLOR_BORDER_DIVIDER_SOFT,
  UI_COLOR_ROW_SELECTED_SOFT,
  UI_COLOR_TEXT_PLACEHOLDER,
  UI_COLOR_TRANSPARENT,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'
import { RBAC_USER_SELECTION_SCROLL_LOAD_THRESHOLD_PX } from '../constants/rbacUserSelectionDialogConstants'

export const RBAC_BULK_REASSIGN_ROLE_REQUIRED_MESSAGE = 'Escoja una opción'
export const RBAC_BULK_REASSIGN_LOAD_ERROR_MESSAGE = 'No se pudieron cargar los usuarios'
export const RBAC_BULK_REASSIGN_SUBMIT_ERROR_MESSAGE = 'No se pudieron reasignar los usuarios'
export const RBAC_BULK_REASSIGN_EMPTY_STATE_MESSAGE = 'No hay usuarios para mostrar'
export const RBAC_BULK_REASSIGN_LOADING_TEXT = 'Cargando...'
export const RBAC_BULK_REASSIGN_SEARCH_PLACEHOLDER = 'Buscar usuario por nombre o código'
export const RBAC_BULK_REASSIGN_ROLE_PLACEHOLDER = 'Busca o selecciona un rol'
export const RBAC_BULK_REASSIGN_NO_ROLES_TEXT = 'No hay roles disponibles'
export const RBAC_BULK_REASSIGN_UNSELECTED_ROW_TEXT = 'Marca la casilla para reasignar'
export const RBAC_BULK_REASSIGN_UNASSIGNED_ROLE_LABEL = 'SIN ROL'

export const RBAC_BULK_REASSIGN_MIN_VISIBLE_ROWS = 4
export const RBAC_BULK_REASSIGN_ROW_MIN_HEIGHT = 88
export const RBAC_BULK_REASSIGN_PAGE_SIZE = 10
export const RBAC_BULK_REASSIGN_SCROLL_LOAD_THRESHOLD_PX =
  RBAC_USER_SELECTION_SCROLL_LOAD_THRESHOLD_PX

export const rbacBulkReassignDialogPaperSx = getDialogPaperSx(920)

export const rbacBulkReassignSearchFieldSx = dialogSearchFieldSx

export const rbacBulkReassignRoleFieldSx = {
  ...dialogSearchFieldSx,
  '& .MuiOutlinedInput-root': {
    ...dialogSearchFieldSx['& .MuiOutlinedInput-root'],
    minHeight: 36
  },
  '& .MuiAutocomplete-clearIndicator': {
    color: UI_COLOR_TEXT_PLACEHOLDER,
    backgroundColor: `${UI_COLOR_TRANSPARENT} !important`
  },
  '& .MuiAutocomplete-clearIndicator:hover': {
    backgroundColor: `${UI_COLOR_TRANSPARENT} !important`,
    color: UI_COLOR_TEXT_PLACEHOLDER
  },
  '& .MuiAutocomplete-popupIndicator': {
    color: UI_COLOR_TEXT_PLACEHOLDER,
    backgroundColor: `${UI_COLOR_TRANSPARENT} !important`
  },
  '& .MuiAutocomplete-popupIndicator:hover': {
    backgroundColor: `${UI_COLOR_TRANSPARENT} !important`,
    color: UI_COLOR_TEXT_PLACEHOLDER
  },
  '& .MuiFormHelperText-root': {
    mx: 0,
    mt: 0.5
  }
}

export const rbacBulkReassignListSx = {
  mt: 1.5,
  border: `1px solid ${UI_COLOR_BORDER_DIVIDER_SOFT}`,
  borderRadius: '8px',
  overflow: 'auto',
  minHeight: RBAC_BULK_REASSIGN_MIN_VISIBLE_ROWS * RBAC_BULK_REASSIGN_ROW_MIN_HEIGHT,
  maxHeight: 440
}

export const rbacBulkReassignRowSx = (selected) => ({
  display: 'grid',
  gridTemplateColumns: {
    xs: '36px 40px minmax(0, 1fr)',
    md: '40px 44px minmax(160px, 1.15fr) minmax(140px, 0.85fr) 28px minmax(220px, 1.15fr)'
  },
  columnGap: 1.5,
  rowGap: 1,
  alignItems: 'center',
  minHeight: RBAC_BULK_REASSIGN_ROW_MIN_HEIGHT,
  px: 1.5,
  py: 1.25,
  backgroundColor: selected ? UI_COLOR_ROW_SELECTED_SOFT : UI_COLOR_WHITE,
  borderBottom: `1px solid ${UI_COLOR_BORDER_DIVIDER_SOFT}`,
  '&:last-of-type': {
    borderBottom: 'none'
  }
})

export const rbacBulkReassignChevronSx = {
  display: { xs: 'none', md: 'flex' },
  justifyContent: 'center'
}

export const rbacBulkReassignHintTextSx = {
  fontSize: 13,
  fontStyle: 'italic'
}
